export function appendComma(parts: any[]): string {
  let commaVal = '';
  if (parts.length == 1) {
    commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}`;
  } else if (parts.length == 2) {
    commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}.${parts[1]}`;
  } else {
    commaVal = '';
  }
  return commaVal;
}
